import { ComponentProps } from "react";
import { cn } from "../../../../utils/cn";
import {
  ACTIVE_TENANT,
  TENANT_PEER_CHECKED_BG_CLASSES,
} from "../../../../constants/tenant_colors";

export interface IInputCheckSlideProps extends ComponentProps<"input"> {
  label?: string;
}

/**
 * Switch liga/desliga sobre um checkbox nativo (`role="switch"`), na cor do tenant ativo.
 * Controlado ou não — repassa `checked`/`onChange`/`disabled` direto ao input, então
 * encaixa em um `Controller` do RHF com `checked={value}` e `onChange={(e) => onChange(e.target.checked)}`.
 */
export const InputSwitch = ({ label, className, ...props }: IInputCheckSlideProps) => {
  return (
    <label
      className={cn(
        "inline-flex w-fit cursor-pointer select-none items-center gap-3 has-[:disabled]:cursor-not-allowed",
        className
      )}
    >
      <input {...props} type="checkbox" role="switch" className="peer sr-only" />
      <span
        aria-hidden
        className={cn(
          "relative h-6 w-11 shrink-0 rounded-full bg-[#d1d5db] transition-colors duration-200",
          "after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-white after:shadow-md after:transition-transform after:duration-200",
          "peer-checked:after:translate-x-5 peer-focus-visible:ring-2 peer-focus-visible:ring-[#2d2d2d]/30 peer-focus-visible:ring-offset-2 peer-disabled:opacity-50",
          TENANT_PEER_CHECKED_BG_CLASSES[ACTIVE_TENANT]
        )}
      />
      {label && (
        <span className="font-['Mulish'] text-sm font-medium text-[#9d9d9d] transition-colors peer-checked:text-[#2d2d2d]">
          {label}
        </span>
      )}
    </label>
  );
};
